import React from 'react';
import OverNLBADetailLayout from '../components/OverNLBADetailLayout';
import banner from '../assets/bg-samenwerkingspartners-1.jpg';
import kwaliteit1 from '../assets/kwaliteit.1.png';
import kwaliteit2 from '../assets/kwaliteit.2.png';
import './OverNLBA.css';

const OverNLBAAccreditatie = () => {
  return (
    <OverNLBADetailLayout
      title="Accreditatie"
      subtitle="Kwaliteitsborging en erkende onderwijsstandaarden als fundament van NLBA."
      heroImage={banner}
      heroAlt="Accreditatie NLBA"
    >
            <h2>Accreditatie</h2>
            
            <p>
              Stel je voor: je wilt gaan studeren. Je hebt een opleiding op het oog en het ziet er allemaal goed uit — 
              mooie website, interessante vakken, enthousiaste docenten. Maar ergens in je achterhoofd denk je: 
              "Is dit eigenlijk wel een goede en erkende studie?"
            </p>
            
            <p>
              Daar komt <strong>accreditatie</strong> om de hoek kijken.
            </p>
            
            <h3>Wat is accreditatie?</h3>
            <p>
              Zie accreditatie als een officieel keurmerk. Een onafhankelijke organisatie komt als het ware "achter de 
              schermen" kijken: hoe goed is het onderwijs, zijn de docenten gekwalificeerd, klopt de inhoud van de 
              opleiding, en worden studenten echt goed voorbereid op de toekomst? Pas als alles aan de juiste normen 
              voldoet, krijgt de opleiding dat belangrijke stempel: geaccrediteerd.
            </p>
            
            <h3>Wie bepaalt dit?</h3>
            <p>
              In Nederland ligt deze taak bij de Nederlands-Vlaamse Accreditatieorganisatie (NVAO). In Suriname wordt dit gedaan door het Nationaal Orgaan voor Accreditatie (NOVA). Deze organisaties beoordelen hogescholen en universiteiten en bepalen of opleidingen voldoen aan de gestelde kwaliteitsstandaarden.
            </p>
            
            <h3>Waarom is dit belangrijk voor jou?</h3>
            <p>
              Stel dat je een studie volgt zonder accreditatie. Dan kun je later ontdekken dat je diploma niet (goed) 
              wordt erkend. Misschien kun je geen studiefinanciering krijgen, of wordt je diploma in het buitenland niet 
              serieus genomen. Dat kan grote gevolgen hebben voor je toekomst.
            </p>
            
            <h3>NLBA's erkenning</h3>
            <p>
              Maar kies je een opleiding die wél geaccrediteerd is door de <strong>NVAO of NOVA</strong>, dan weet je:
            </p>
            <ul className="over-nlba-list">
              <li>Dit onderwijs is gecontroleerd, betrouwbaar en van goede kwaliteit.</li>
              <li>Je diploma heeft waarde — niet alleen in eigen land, maar vaak ook internationaal.</li>
            </ul>
            
            <p>
              <strong>Kort gezegd:</strong> accreditatie is jouw zekerheid dat je studie echt de moeite waard is.
            </p>

            <div className="over-nlba-accreditation-logos">
              <div className="over-nlba-accreditation-logos-grid">
                <div className="over-nlba-accreditation-logo-item">
                  <img src={kwaliteit1} alt="Accreditatie logo 1" loading="lazy" />
                </div>
                <div className="over-nlba-accreditation-logo-item">
                  <img src={kwaliteit2} alt="Accreditatie logo 2" loading="lazy" />
                </div>
              </div>
            </div>
    </OverNLBADetailLayout>
  );
};

export default OverNLBAAccreditatie;
